import { inject, observer } from "mobx-react";
import { Layout, Menu } from "antd";
import { RouterStore } from "mobx-react-router";
import { Link } from "react-router-dom";
import * as React from "react";

import UserInfo from "./UserInfo";
import menuConfig from "./menu";

interface SidebarProps {
  routerStore?: RouterStore;
}

@inject("routerStore")
@observer
class Sidebar extends React.Component<SidebarProps> {
  public render() {
    const { location } = this.props.routerStore!;
    const currentItem = menuConfig.find((item) =>
      location.pathname.startsWith(item.url),
    );
    return (
      <Layout.Sider width="140">
        <UserInfo />
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={currentItem ? [currentItem.itemKey] : []}
        >
          {menuConfig.map((menuItem) =>
            menuItem.items ? (
              <Menu.SubMenu key={menuItem.itemKey} title={menuItem.name}>
                {menuItem.items.map((item) => (
                  <Menu.Item key={menuItem.itemKey}>
                    <Link to={item.url}>{item.name}</Link>
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            ) : (
              <Menu.Item key={menuItem.itemKey}>
                <Link to={menuItem.url}>{menuItem.name}</Link>
              </Menu.Item>
            ),
          )}
        </Menu>
      </Layout.Sider>
    );
  }
}

export default Sidebar;
